var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIcondevicesoutletsquaresolid = function SvgIcondevicesoutletsquaresolid(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Devices/SquareTemplate/devices.outlet.square.solid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Devices/SquareTemplate/devices.outlet.square.solid",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sensor-Icon",
    fill: "#FFFFFF",
    stroke: "#666666"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 40,
    cy: 40,
    r: 39.5
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#666666",
    x: 29,
    y: 25,
    width: 4,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#666666",
    x: 47,
    y: 27,
    width: 4,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,49 C42.209139,49 44,50.790861 44,53 L44,57 L44,57 L36,57 L36,53 C36,50.790861 37.790861,49 40,49 Z",
    id: "Rectangle",
    fill: "#666666"
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIcondevicesoutletsquaresolid);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.devices.outlet.square.solid.b5b29aa2bc9a074d20ebb887de938e48.svg";